import ColorField from './component'

export default ColorField
